var render = function () {
  var _vm$radioList;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return (_vm$radioList = _vm.radioList) !== null && _vm$radioList !== void 0 && _vm$radioList.length ? _c('div', {
    staticClass: "tabs",
    class: {
      tabs_delivery: _vm.deliveryView
    }
  }, [_c('div', {
    staticClass: "tabs__mobile"
  }, [_c('RadioListBlock', {
    attrs: {
      "data-e2e": "order-delivery-type-list",
      "model-value": _vm.value,
      "list": _vm.radioList
    },
    on: {
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var el = _ref.el;
        return [_vm._v("\n      " + _vm._s(el.name) + "\n    ")];
      }
    }], null, false, 3103563224)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs__desktop"
  }, [_vm._l(_vm.list, function (type) {
    var _type$image;

    return _c('div', {
      key: type.id,
      staticClass: "tabs__tab",
      class: {
        tabs__tab_active: type.id === _vm.value
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('change', type);
        }
      }
    }, [_c('div', {
      staticClass: "tabs__tab-text"
    }, [_vm._v("\n        " + _vm._s(type.title) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "tabs__subtext fz-12 lh-14 mt-2 grey-text"
    }, [_vm._v("\n        " + _vm._s(_vm.getSubtext(type)) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "tabs__img-wrap"
    }, [_c('img', {
      staticClass: "tabs__img",
      attrs: {
        "src": (_type$image = type.image) !== null && _type$image !== void 0 ? _type$image : _vm.getPhoto(type.title),
        "alt": type.title
      }
    })])]);
  }), _vm._v(" "), _vm.deliveryView && _vm.userEmail ? _c('div', {
    staticClass: "tabs__tab tabs__tab_experiment",
    on: {
      "click": _vm.openRefiner
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tabs__subtext fz-12 lh-14 mt-2 grey-text"
  }, [_vm._v("\n        100–500 ₽, 30 мин\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tabs__img-wrap"
  }, [_c('img', {
    staticClass: "tabs__img",
    attrs: {
      "src": _vm.getPhoto('Экспресс-доставка*'),
      "alt": "Экспресс-доставка"
    }
  })])]) : _vm._e()], 2)]) : _c('div', {
    staticClass: "delivery__not-delivery"
  }, [_vm._v("\n  " + _vm._s(_vm.emptyText) + "\n")]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tabs__tab-text"
  }, [_vm._v("\n        Экспресс-доставка"), _c('span', {
    staticClass: "tabs__tab-footnote"
  }, [_vm._v("*")])]);
}]

export { render, staticRenderFns }